import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initAuth } from '@alchemiesolns/product-registration';
import { initUserAccess, getBearerToken } from '@alchemiesolns/user-access';
import { initStoreApi } from '@alchemiesolns/store-api';
import App from './App';
import './index.css';
import { prefetchPTSansBoldForExport } from './utils/fontEmbed';

initUserAccess(
  {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string | undefined,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string | undefined,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  },
  {
    // Where a verification / password-reset link returns the user (STEM-363).
    // Unset in an environment whose origin is not in that Firebase project's
    // authorized domains — a value that is not authorized makes the send throw,
    // which aborts registration. Set for production, where `piph.alchem.ie` is
    // confirmed authorized on `alchemie-commerce`.
    continueUrl: import.meta.env.VITE_AUTH_CONTINUE_URL as string | undefined,
  },
);

const profileReadBaseEnv = import.meta.env.VITE_USER_PROFILE_FUNCTION_BASE;

// `/pricingFor` expects Firestore `licensedProducts/{productId}.stripePriceIds` to be configured.
initStoreApi({
  apiBase: import.meta.env.VITE_API_BASE ?? '',
  getBearerToken,
  userProfileReadBase:
    profileReadBaseEnv !== undefined && String(profileReadBaseEnv).trim() !== ''
      ? String(profileReadBaseEnv).trim().replace(/\/$/, '')
      : import.meta.env.DEV
        ? ''
        : undefined,
});

prefetchPTSansBoldForExport();

initAuth({
  forceLicenseGateInDev: import.meta.env.VITE_FORCE_AUTH_GATE === 'true',
}).then(() => {
  // BASE_URL tracks the Vite `--base` flag (default '/'). For prod we
  // build with `--base=/author/`, so basename becomes `/author`.
  // Local dev (`npm run dev`) and the existing `npm run deploy` test
  // path keep BASE_URL='/' and basename stays `/` — no behavior change.
  const baseUrl = import.meta.env.BASE_URL ?? '/';
  const routerBasename = baseUrl.replace(/\/$/, '') || '/';

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter basename={routerBasename}>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
});
